import { NgModule } from '@angular/core';
import { DataService } from '../shared/core.index';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { OnlyNumbersDirective } from '../shared/directives/only-number/only-numbers.directive';
import { RoleBasedAccessDirective } from '../shared/directives/RoleBasedAccess/role-based-access.directive';
import { WidgetLoaderComponent } from './components/widget-loader/widget-loader.component';
import { PaginationComponent } from './components/pagination/pagination.module';
import { Select2Component } from './components/select2/select2.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';

@NgModule({
  declarations: [
    PaginationComponent,
    Select2Component,
  ],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    OnlyNumbersDirective, //Standalone Component so need to imports not declaration,
    RoleBasedAccessDirective,//Standalone Component so need to imports not declaration,
    WidgetLoaderComponent,//Standalone Component so need to imports not declaration,
    SearchableSelectComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OnlyNumbersDirective,  //Standalone Directive so need to imports not declaration,
    RoleBasedAccessDirective,//Standalone Directive so need to imports not declaration,
    WidgetLoaderComponent, //Standalone Component so need to imports not declaration,
    PaginationComponent,
    Select2Component,
    SearchableSelectComponent
  ],
  providers: [
    DataService,
    DatePipe
  ],
})
export class SharedModule { }
